'use client'

import { CustomSelect } from './form/CustomSelect'
import Typography from './Typography'

const THEMES = {
  dark: {
    activeText: 'text-dark-blue-dark-blue2',
    inactiveText: 'text-basic-black',
    border: 'border-basic-black',
    indicator: 'bg-style1',
  },
  dark2: {
    activeText: 'text-dark-blue-dark-blue2',
    inactiveText: 'text-basic-black',
    border: 'border-b-0',
    indicator: 'bg-style1',
  },
  journalDomain: {
    activeText: 'text-basic-black',
    inactiveText: 'text-basic-black',
    border: 'border-b-0',
    indicator: 'bg-basic-black',
  },
  light: {
    activeText: 'text-basic-white',
    inactiveText: 'text-basic-white/70',
    border: 'border-basic-white/30',
    indicator: 'bg-style1',
  },
}

export default function Tabs({
  tabs = [],
  activeTab,
  onTabChange = () => {},
  color = 'dark',
  className = '',
  ariaLabel = 'Tabs',
}) {
  const theme = THEMES[color] || THEMES.dark
  const filteredTabs = Array.isArray(tabs) ? tabs.filter((tab) => tab?.label) : []

  if (!filteredTabs.length) {
    return null
  }

  const selectOptions = filteredTabs.map((tab) => ({
    value: tab.id || tab.label,
    label: tab.label,
  }))
  const selectColor = color === 'light' ? 'light' : color === 'journalDomain' ? 'journalDomain' : 'light-blue'
  const selectDefaultValue = activeTab || selectOptions[0]?.value

  return (
    <>
      <div className={`d:hidden w-full ${className}`}>
        <CustomSelect
          label={ariaLabel}
          labelShow={false}
          name="tabs-select"
          classNameContainer="w-full"
          color={selectColor}
          options={selectOptions}
          defaultValue={selectDefaultValue}
          onChange={(event) => {
            const value = event?.target?.value
            if (value !== undefined) {
              onTabChange(value)
            }
          }}
        />
      </div>

      <nav className={`hidden flex-wrap gap-y-10 d:flex ${className}`} aria-label={ariaLabel}>
        {filteredTabs.map((tab) => {
          const tabId = tab.id || tab.label
          const isActive = tabId === activeTab
          const textColor = isActive ? theme.activeText : theme.inactiveText

          return (
            <button
              key={tabId}
              type="button"
              className={`relative cursor-pointer border-b ${theme.border} px-24 pb-10 text-left transition-colors duration-200 ${textColor}`}
              aria-pressed={isActive}
              aria-current={isActive ? 'true' : undefined}
              onClick={() => onTabChange(tabId)}
            >
              <Typography variant="body3" component="span" color={textColor} className="tracking-2 uppercase">
                {tab.label}
              </Typography>
              {isActive && (
                <span
                  className={`pointer-events-none absolute inset-x-0 bottom-0 h-4 ${theme.indicator}`}
                  aria-hidden
                />
              )}
            </button>
          )
        })}
      </nav>
    </>
  )
}
